import { useCurrentUserProfile } from "@/hooks/current-user-profile.hook";
import { useDimensionByQuizId } from "@/hooks/dimension-by-quiz-id.hook";
import { getDimensionById } from "@/lib/dimensions";
import TopicAccordionItem from "@/modules/quiz/dimension/topic-accordion-item";
import { DimensionId } from "@/types/questionnaries";
import { useParams } from "react-router-dom";
import TopicsSkeleton from "./topics-skeleton";

const Topics = () => {
  const { quizId, dimensionId: dimensionIdParam } = useParams();

  if (!dimensionIdParam) {
    throw new Error("Dimension param not defined");
  }

  const dimensionId = dimensionIdParam as DimensionId;

  const dimension = getDimensionById(dimensionId);

  if (!dimension) {
    throw new Error("Dimension not found");
  }

  const { data: userProfile } = useCurrentUserProfile();

  const { data: dimensionSummary, isLoading: isDimensionSummaryLoading } =
    useDimensionByQuizId({
      companyId: userProfile?.companyId || "",
      applicationQuizId: quizId || "",
      dimension: dimensionId,
    });

  if (isDimensionSummaryLoading) {
    return <TopicsSkeleton />;
  }

  return (
    Array.isArray(dimensionSummary?.topics) && (
      <div className="flex flex-col gap-5">
        {dimensionSummary.topics.map((topic, index) => (
          <TopicAccordionItem
            key={topic.topic}
            topic={topic}
            order={index + 1}
            disabled={true}
            showResults={true}
            showEvidences={dimensionSummary.group !== "GENERAL_INFORMATION"}
          />
        ))}
      </div>
    )
  );
};

export default Topics;
